/**
 * Property workflow step (status) options for filter dropdowns and statistics.
 * Used on Admin and Super Admin properties listing pages.
 */
export const PROPERTY_STATUS_OPTIONS = [
  { value: "Request_Submission", label: "Request Submission" },
  { value: "Pending", label: "Pending" },
  { value: "First_Inspection", label: "First Inspection" },
  { value: "Inspection", label: "Inspection" },
  { value: "Inspection_Completed", label: "Inspection Completed" },
  { value: "Inspection_Offer", label: "Inspection Offer" },
  { value: "Contracting", label: "Contracting" },
  { value: "Preparation", label: "Preparation" },
  { value: "Second_Inspection", label: "Second Inspection" },
  { value: "Second_Inspection_Completed", label: "Second Inspection Completed" },
  { value: "Legalization", label: "Legalization" },
  { value: "Photo_Shooting", label: "Photo Shooting" },
  { value: "Active", label: "Active" },
  { value: "Approved", label: "Approved" },
  { value: "Rejected", label: "Rejected" },
  { value: "Suspended", label: "Suspended" },
  { value: "Maintenance", label: "Maintenance" },
  { value: "Disabled", label: "Disabled" },
  { value: "Closed", label: "Closed" },
  { value: "OnClosure", label: "On Closure" },
];
